// extracted by mini-css-extract-plugin
export default {"mainWrapper":"SlotSelectorWrapper_mainWrapper__zMKcM","mainContainer":"SlotSelectorWrapper_mainContainer__gtgZL","mainContent":"SlotSelectorWrapper_mainContent__R4XEG"};